<template>
  <v-container grid-list-lg>
    <v-layout flex align-center justify-center row wrap>
      <v-flex xs12>
        <v-toolbar height="56" color="primary">
          <v-toolbar-title id="idCabecalhoJanela" class="subheading white--text">
            {{ this.$route.params.id ? 'Editar Grupo de Usuários': 'Adicionar Grupo de Usuários' }}
          </v-toolbar-title>
        </v-toolbar>
        <v-card>
          <v-card-text>
            <v-container grid-list-lg>
              <v-form ref="formCadastroGrupo" v-model="formValidCadastroGrupo">
                <v-layout row wrap>
                  <v-flex xs12 sm5>
                    <v-text-field label="Nome do Grupo*"
                      id="txtCadastroGrupoNome"
                      ref="txtCadastroGrupoNomeRef"
                      v-model="grupoModel.nome"
                      @change="validaNomeGrupo()"
                      :rules="formRulesComputed.grupo.nome(grupoModel.nome, nomeDeGrupoValido)"
                    ></v-text-field>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex xs12 sm4>
                    <v-select label="Status*"
                      id="txtCadastroGrupoStatus"
                      ref="txtCadastroGrupoStatusRef"
                      :items="[{text: 'Ativo', value: true}, {text: 'Inativo', value: false}]"
                      item-text="text"
                      item-value="value"
                      :rules="formRulesComputed.grupo.status(grupoModel.ativo)"
                      v-model="grupoModel.ativo"
                    ></v-select>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex xs12 sm5>
                    <v-autocomplete label="Vincular Usuário*"
                      id="txtCadastroGrupoUsuario"
                      ref="txtCadastroGrupoUsuarioRef"
                      :items="listaUsuariosFiltrada"
                      item-text="nome"
                      no-data-text= "Nenhum Usuário Para Adicionar"
                      :rules="usuariosRule"
                      v-model="usuarioSelecionado"
                      @input="validaInsercaoUsuario()"
                      return-object
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-btn fab small dark 
                      color="secondary"
                      :disabled="!usuarioSelecionado || !usuarioSelecionadoValido"
                      @click="insereUsuario()">
                      <v-icon>add</v-icon> 
                    </v-btn>
                  </v-flex>
                  <v-flex xs12 mt-4>
                    <template v-for="usuario in grupoModel.usuarios">              
                          <v-chip :key="usuario.id" close @input="removeChipUsuario(usuario.id)">{{ usuario.nome }}</v-chip>
                    </template>
                  </v-flex>
                  <v-flex xs12>
                    <br>
                    <h4 class="primary--text">Configurar Regional?*</h4>
                    <v-radio-group id="regionalRadioGroup" v-model="grupoModel.regional" row required>
                      <v-radio id="regionalRadioSim" label="Sim" :value="true" color="primary"></v-radio>
                      <v-radio id="regionalRadioNao" label="Não" :value="false" color="primary"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-layout row wrap v-if="grupoModel.regional">
                    <v-flex xs12 sm5>
                      <v-autocomplete label="Vincular Estados*"
                        id="txtEstadosDisponiveis"
                        ref="txtEstadosDisponiveisRef"
                        :items="listaEstados"
                        item-text="sigla"
                        no-data-text= "Nenhum Estado Para Adicionar"
                        v-model="estadoSelecionado"
                        :rules="formRulesComputed.grupo.estado(estadoSelecionado, estadoSelecionadoValido, estadoSelecionadoInvalidoUso)"
                        @input="validaEstadoSelecionado()"
                        return-object
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm1>
                      <v-btn fab small dark id="insereEstadoBtn"
                        color="cyan darken-1"
                        :disabled="!estadoSelecionado || !estadoSelecionadoValido || !grupoModel.regional"
                        @click="insereEstado()">
                        <v-icon>add</v-icon> 
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 sm5>
                      <v-text-field label="E-mail da Regional*"
                        id="txtEmailRegional"
                        ref="txtEmailRegionalRef"
                        v-model="emailRegional"
                        :rules="formRulesComputed.grupo.emailRegional(emailRegional ? emailRegional : '', grupoModel.regional)"
                        validate-on-blur
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 mt-4>
                      <template v-for="estado in listaEstadosEmEdicao">              
                        <v-chip :id="'estado-' + estado.id + '-chip'" :key="estado.id" close @input="removeChipEstado(estado.id)">{{ estado.sigla }}</v-chip>
                      </template>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 mt-4>
        <v-btn text-md-left text-xs-center
          id="btnVoltarCadastroGrupo"
          ref="btnVoltarCadastroGrupoRef"
          :block="$vuetify.breakpoint.xsOnly" 
          class="white--text left"
          @click.native="voltar()"
          color="primary"
          flat>
            Voltar
        </v-btn>
        <v-btn text-md-right text-xs-center :disabled="disableSalvar"
          id="btnSalvarCadastroGrupo"
          ref="btnSalvarCadastroGrupoRef"
          :block="$vuetify.breakpoint.xsOnly" 
          :loading="loadingSalvar" 
          class="white--text right"
          @click.native="salvarGrupo()"
          color="primary">
            Salvar
          <v-icon right class="hidden-sm-and-down">save</v-icon>
        </v-btn>
      </v-flex>
      <v-snackbar
        :timeout="6000"
        :color="snackbar.sucesso ? 'success' : 'error'"
        multi-line
        v-model="snackbar.visivel">
          {{ snackbar.mensagem }}
          <v-btn dark flat @click.native="snackbar.visivel = false">Fechar</v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
import perfil from '@/helpers/perfil';
import usuarioHelper from '@/helpers/usuario-logado';
import auditoria from '@/helpers/auditoria';
import functions from '@/components/pages/grupo-usuarios/functions.js';
import formRules from '@/helpers/form-rules';

export default {
  name: 'CadastroGrupos',
  data: () => {
    return {
      formValidCadastroGrupo: false,
      nomeDeGrupoValido: true,
      loadingSalvar: false,
      time: null,
      usuarioSelecionado: null,
      usuarioSelecionadoValido: false,
      listaUsuarios: [],
      listaEstados: [],
      listaEstadosEmEdicao: [],
      listaEstadosEmUso: [],
      estadoSelecionado: null,
      estadoSelecionadoValido: false,
      estadoSelecionadoInvalidoUso: null,
      emailRegional: '',
      grupoEmEdicao: null,
      grupoModel: {
        id: null,
        nome: null,
        ativo: true,
        usuarios: [],
        regionalList: [],
        regional: false
      },
      insercaoUsuario: {
        mensagem: undefined,
        sucesso: true
      },
      snackbar: {
        visivel: false,
        sucesso: false,
        mensagem: ''
      }
    }
  },
  computed: {
    formRulesComputed: function() {
      return formRules;
    },
    disableSalvar: function() {
      const self = this;
      var regionalInvalida;
      var camposBasicosInvalidos = !self.nomeDeGrupoValido || self.grupoModel.usuarios.length == 0 || self.loadingSalvar;
      
      if (self.grupoModel.regional) {
        if (self.grupoModel.regionalList && self.emailRegional) {
          regionalInvalida =  !(!self.grupoModel.regionalList.length == 0 &&
                              /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(self.emailRegional));
        } else {
          regionalInvalida = true;
        }
      } else {
        regionalInvalida = false;
      }

      return camposBasicosInvalidos || regionalInvalida;
    },
    listaUsuariosFiltrada: function() {
      var usuariosDoGrupo = this.grupoModel.usuarios;
      return this.listaUsuarios
        .filter(function(e) {
          return !usuariosDoGrupo.some(function(u) { return u.id === e.id; });
        })
        .sort((a, b) => { return a.nome.localeCompare(b.nome) });
    },
    usuariosRule: function () {
        return [(this.insercaoUsuario.sucesso) || this.insercaoUsuario.mensagem];
    }
  },
  watch: {

  },
  mounted: async function() {
    this.inicializaListaEstadosEmEdicao();
    if(this.$route.params.id) {
      await this.buscaGrupo()
    }
    this.buscaUsuarios();
    this.buscaEstados();
  },
  methods: {
    validaNomeGrupo: function() {
      const self = this;
      self.$store.commit('startLoading');
      axios.get(`${process.env.URL_GRUPOMS}/v1/validaNomeDeGrupo?nome=${self.grupoModel.nome}`, {
        headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` }}) 
      .then((response) => {
        self.nomeDeGrupoValido  = response.data;
        self.$store.commit('endLoading');
      })
      .catch((err) => {
        self.$store.commit('endLoading');
        self.snackbar.visivel = true;
        self.snackbar.sucesso = false;
        self.snackbar.mensagem = 'Ocorreu um erro ao validar o nome do grupo';                      
      });
    },
    validaInsercaoUsuario: function() {
      const self = this;
      self.$store.commit('startLoading');
      var url = `${process.env.URL_GRUPOMS}/v1/validaInsercaoUsuarioAoGrupo`;
      if (self.grupoModel.id) {
        url += `?idGrupo=${self.grupoModel.id}`;
      }
      axios.post(url, self.usuarioSelecionado, {
        headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` }})
      .then((response) => {
        self.insercaoUsuario = response.data;
        self.usuarioSelecionadoValido = self.insercaoUsuario.sucesso;
        self.$store.commit('endLoading');
      })
    },
    insereUsuario: function () {
      const self = this;
      if(self.usuarioSelecionadoValido) {
        self.grupoModel.usuarios.push(self.usuarioSelecionado);
        self.usuarioSelecionado = null;
      }
    },
    removeChipUsuario: function(idUsuario) {
      const self = this;
      self.grupoModel.usuarios.splice(self.grupoModel.usuarios.findIndex(i => i.id == idUsuario), 1);
    },
    buscaGrupo: async function() {
      const self = this;
      self.$store.commit('startLoading');
      await axios.get(`${process.env.URL_GRUPOMS}/v1/buscaGrupoPorId?id=${this.$route.params.id}`, {
        headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` }}) 
      .then((response) => {
        const data = response.data;
        self.grupoModel = data;
        self.grupoEmEdicao = JSON.parse(JSON.stringify(self.grupoModel));
        self.emailRegional = self.grupoEmEdicao.regionalList.length > 0 ? self.grupoEmEdicao.regionalList[0].email : '';
        self.$store.commit('endLoading');
      })
      .catch((err) => {
        self.$store.commit('endLoading');
        self.snackbar.visivel = true;
        self.snackbar.sucesso = false;
        self.snackbar.mensagem = 'Ocorreu um erro ao buscar o grupo';                      
      });
    },
    buscaUsuarios: function() {
      const self = this;
      self.$store.commit('startLoading');
      axios.get(`${process.env.URL_USUARIOMS}/v1/buscaUsuariosVinculaveisAoGrupo`, {
        headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` }}) 
      .then((response) => {
        self.listaUsuarios = response.data;
        self.$store.commit('endLoading');
      })
      .catch((err) => {
        self.$store.commit('endLoading');
        self.snackbar.visivel = true;
        self.snackbar.sucesso = false;
        self.snackbar.mensagem = 'Ocorreu um erro ao buscar lista de usuários';                      
      });
    },
    buscaEstados: function() {
      const self = this;
      self.$store.commit('startLoading');
      axios.get(`${process.env.URL_GEOMS}/v1/no-auth/buscaTodosEstadosSemDiversos`) 
      .then((response) => {
        self.listaEstados = response.data;
        self.filtraEstadosEmUso();
        self.buscaEstadosEmUso();
        self.$store.commit('endLoading');
      })
      .catch((err) => {
        self.$store.commit('endLoading');
        self.snackbar.visivel = true;
        self.snackbar.sucesso = false;
        self.snackbar.mensagem = 'Ocorreu um erro ao buscar lista de estados';                      
      });
    },
    buscaEstadosEmUso: function() {
      const self = this;
      axios.get(`${process.env.URL_GRUPOMS}/v1/getEstadosEmUso`, {
        headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` }}) 
      .then((response) => {
        self.listaEstadosEmUso = response.data;
      })
      .catch((err) => {
        self.$store.commit('endLoading');
        self.snackbar.visivel = true;
        self.snackbar.sucesso = false;
        self.snackbar.mensagem = 'Ocorreu um erro ao buscar a lista de estados';                      
      });
    },
    filtraEstadosEmUso: function() {
      const self = this;
      if (self.listaEstados.length > 0 && self.grupoModel.regionalList.length > 0) {
        self.grupoModel.regionalList.forEach((regional) => {
          self.listaEstados = self.listaEstados.filter((estado) => {
            if (estado.id == regional.idEstado) {
              self.listaEstadosEmEdicao.push(estado);
            }
            return estado.id != regional.idEstado;
          });
        })
      }
    },
    validaEstadoSelecionado: function() {
      const self = this;
      self.$store.commit('startLoading');
      axios.get(`${process.env.URL_GRUPOMS}/v1/validaAssociacaoRegionalGrupo?idEstado=${self.estadoSelecionado.id}&idGrupo=${self.grupoModel.id ? self.grupoModel.id : 0}`, {
        headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` }}) 
      .then((response) => {
        self.estadoSelecionadoValido = response.data == 'OK' ? true : false;
        self.estadoSelecionadoInvalidoUso = response.data != 'OK' ? response.data : null;
        self.$store.commit('endLoading');
      })
    },
    insereEstado: function () {
      const self = this;
      if (!self.grupoModel.regionalList) {
        self.grupoModel.regionalList = [];
      }
      if (!self.listaEstadosEmEdicao) {
        self.listaEstadosEmEdicao = [];
      }
      if(self.estadoSelecionadoValido) {
        self.listaEstadosEmEdicao.push(self.estadoSelecionado);
        self.grupoModel.regionalList.push( {idPais: 1, idEstado: self.estadoSelecionado.id} );
        self.listaEstados = self.listaEstados.filter((estado) => {
          return estado.id != self.estadoSelecionado.id;
        })
        self.estadoSelecionado = null;
      }
    },
    removeChipEstado: function(idEstado) {
      const self = this;
      self.listaEstados.push(self.listaEstadosEmEdicao.find((estado) => {
        return estado.id == idEstado;
      }));
      self.listaEstados = self.listaEstados.sort((primeiro, segundo) => {
        return primeiro.id - segundo.id;
      });
      self.grupoModel.regionalList = self.grupoModel.regionalList.filter((regional) => {
        return regional.idEstado != idEstado;
      });
      self.listaEstadosEmEdicao = self.listaEstadosEmEdicao.filter((estado) => {
        return estado.id != idEstado;
      });
    },
    salvarGrupo: function() {
      const self = this;
      self.$store.commit('startLoading');
      self.loadingSalvar = true;
      self.addEmailNasRegionais();
      
      axios.post(`${process.env.URL_GRUPOMS}/v1/cadastraGrupo`, self.grupoModel, {
        headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` }}) 
      .then((response) => {  
        auditoria.registrar(self.montaStringDescricaoAuditoria(), '', '' );
        self.loadingSalvar = false;
        self.$store.commit('endLoading');
        self.go('GestaoGrupos', {snackbarText: `Grupo ${self.$route.params.id ? 'editado ':'criado '} com sucesso`, snackbarMostrar: true, snackbarSucesso: true});
      })
      .catch((err) => {
        self.loadingSalvar = false;
        self.$store.commit('endLoading');
        self.snackbar.visivel = true;
        self.snackbar.sucesso = false;
        self.snackbar.mensagem = `Ocorreu um erro ao ${self.$route.params.id ? 'cadastrar ':'criar '} grupo`;                      
      });
    },
    montaStringDescricaoAuditoria: function() {
      const self = this;
      let usuarios = functions.formatacao.formataStringUsuarios(self.grupoModel);
      if (!self.$route.params.id) {
        return `Cadastrado grupo de usuários: ${self.grupoModel.nome}.
                Status: ${self.grupoModel.ativo? 'Ativo' : 'Inativo'}.
                Usuários: ${usuarios}.
                ${self.grupoModel.regional ?
                `Regional: Sim.
                E-mail da regional: ${self.grupoModel.regionalList[0].email}.
                Estados:${self.listaEstadosEmEdicao.map((estado) => {
                  return ' ' + estado.nome;
                })}` : `Regional: Não`}`;
      } else {
        let mensagem = `Alterado cadastro do grupo de usuários: ${self.grupoModel.nome}. `;
        if(self.grupoModel.ativo != self.grupoEmEdicao.ativo) {
          mensagem += `Status: ${self.grupoModel.ativo? 'Ativo' : 'Inativo'}. `
        }
        if(JSON.stringify(self.grupoModel.usuarios.sort((a, b) => { return a.nome.localeCompare(b.nome) })) 
        != JSON.stringify(self.grupoEmEdicao.usuarios.sort((a, b) => { return a.nome.localeCompare(b.nome) }))) {
          mensagem += `Usuários: ${usuarios}. `
        }
        if (self.grupoModel.regional != self.grupoEmEdicao.regional) {
          mensagem += `Regional: ${self.grupoModel.regional ? `sim` : `não`}. `
        }
        if (self.grupoModel.regional) {
          if (self.grupoEmEdicao.regional) {
            if (self.grupoModel.regionalList[0].email != self.grupoEmEdicao.regionalList[0].email) {
              mensagem += `E-mail da regional: ${self.grupoModel.regionalList[0].email} `
            }
            if(JSON.stringify(self.grupoModel.regionalList.sort((a, b) => { return a.idEstado - b.idEstado })) 
            != JSON.stringify(self.grupoEmEdicao.regionalList.sort((a, b) => { return a.idEstado - b.idEstado }))) {
              mensagem += `Estados remanescentes:${self.listaEstadosEmEdicao.map((estado) => {
                      return ' ' + estado.nome;
              })}. `
            }
          } else {
            mensagem += `E-mail da regional: ${self.grupoModel.regionalList[0].email} `;
            mensagem += `Estados adicionados:${self.listaEstadosEmEdicao.map((estado) => {
                    return ' ' + estado.nome;
            })}. `;
          }
        }
        return mensagem;
      }
    },
    inicializaListaEstadosEmEdicao: function() {
      if (!this.listaEstadosEmEdicao) {
        this.listaEstadosEmEdicao = [];
      }
    },
    addEmailNasRegionais: function() {
      const self = this;
      self.grupoModel.regionalList.forEach((regional) => {
        regional.email = self.emailRegional;
      })
    },
    voltar: function() {
      const self = this;
      self.$router.push('/GestaoGrupos')
    },
    go: function(routeName, routeParams) {
      const self = this;
      if (!routeParams) {
        self.$router.push({name: routeName});
      } else {
        self.$router.push({name: routeName, params: routeParams});
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/grupo-usuarios/CadastroGrupos.vue